import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import type {
  CreativeEditorDialogProps,
  CreativeEditorSectionProps,
} from "@/types/creative-library";
import { CREATIVE_LIBRARY_ICONS } from "./creative-library-visuals";

/** One layout owner for the Library's identity, Board and reference forms. */
export function CreativeEditorDialog({
  open,
  busy,
  onClose,
  kind,
  title,
  description,
  testId,
  children,
  footer,
  size = "form",
}: CreativeEditorDialogProps) {
  const Icon = CREATIVE_LIBRARY_ICONS[kind];
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next && !busy) onClose();
      }}
    >
      <DialogContent
        className="flex max-h-[90dvh] w-full max-w-none flex-col gap-0 overflow-hidden p-0 sm:p-0"
        style={{
          width: `min(calc(100vw - 2rem), ${size === "preview" ? "64rem" : "42rem"})`,
        }}
        data-testid={testId}
      >
        <DialogHeader className="shrink-0 space-y-0 border-b border-border bg-background px-5 py-5 pr-12 text-left sm:px-6 sm:pr-14">
          <div className="flex min-w-0 items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <Icon className="h-5 w-5" aria-hidden="true" />
            </div>
            <div className="min-w-0 space-y-1">
              <DialogTitle className="break-words text-xl leading-snug">
                {title}
              </DialogTitle>
              <DialogDescription className="break-words text-sm leading-relaxed">
                {description}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto px-5 py-5 sm:px-6">
          {children}
        </div>
        <div className="flex shrink-0 flex-wrap justify-end gap-2 border-t border-border bg-background px-5 py-4 sm:px-6 [&_button]:shrink-0 [&_button]:gap-2">
          {footer}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function CreativeEditorSection({
  children,
  className,
}: CreativeEditorSectionProps) {
  return (
    <section
      className={cn(
        "flex flex-col gap-3 rounded-xl border border-border bg-background p-4",
        className,
      )}
    >
      {children}
    </section>
  );
}
